import { ChangeDetectorRef, Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AsyncState } from '@cawita/core-front/state';
import { Partner, Stay } from '@shared/models';
import { SubSink } from 'subsink';
import { StayState, StayStore } from '../stay.store';
import { PartnerMetadata } from '../api/partner.api';

export interface ActivePartnerContext {
  $implicit: Partner;
  metadata: PartnerMetadata;
  stay: Stay;
  allStays: Stay[];
  otherStays: Stay[];
}

@Directive({ selector: '[cwtActivePartner]' })
export class ActivePartnerDirective implements OnInit, OnDestroy {
  public static ngTemplateContextGuard(_dir: ActivePartnerDirective, ctx: unknown): ctx is ActivePartnerContext { return true; }

  private sub = new SubSink();
  private ctx: ActivePartnerContext = {
    $implicit: null,
    stay: null,
    metadata: null,
    allStays: [],
    otherStays: []
  };

  constructor(
    protected store: StayStore,
    protected tRef: TemplateRef<ActivePartnerContext>,
    protected vcRef: ViewContainerRef,
    protected cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.sub.sink = this.store.state$.subscribe((state) => this._onStateChange(state));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private _onStateChange(state: StayState & AsyncState) {
    this.vcRef.clear();
    if (state.initialized) {
      this.ctx.$implicit = state.activePartner;
      this.ctx.stay = state.activeStay;
      this.ctx.allStays = state.allStays;
      this.ctx.otherStays = state.otherStays;
      this.ctx.metadata = state.metadata;
      const ref = this.vcRef.createEmbeddedView(this.tRef, this.ctx);
      ref.detectChanges();
    }
  }
}